// Philippines Company/Client Master Mock Data

import SvgIconeye from "../../../../assets/icons/SvgIconeye";

const Productdata = [
  {
    id: 1,
    companyCode: "CORP-001",
    companyName: "SM Prime Holdings Inc.",
    companyType: "Corporate",
    industry: "Real Estate & Retail",
    registrationNo: "SEC-1991-0654321",
    tin: "000-123-456-000",
    address: "Mall of Asia Complex, Pasay City",
    city: "Pasay",
    province: "Metro Manila",
    contactPerson: "Juan Carlos Mendoza",
    contactNumber: "+63 2 8831 1000",
    email: "insurance@smprime.com",
    website: "www.smprime.com",
    totalPolicies: 45,
    totalPremium: "₱12,500,000",
    status: "Active",
    modifiedBy: "Roberto Reyes",
    modifiedOn: "03/28/2025",
    action: <SvgIconeye/>
  },
  {
    id: 2,
    companyCode: "CORP-002",
    companyName: "Ayala Corporation",
    companyType: "Corporate",
    industry: "Conglomerate",
    registrationNo: "SEC-1968-0123456",
    tin: "000-234-567-000",
    address: "Makati Avenue, Makati City",
    city: "Makati",
    province: "Metro Manila",
    contactPerson: "Maria Teresa Santos",
    contactNumber: "+63 2 7908 3000",
    email: "riskmanagement@ayala.com.ph",
    website: "www.ayala.com.ph",
    totalPolicies: 68,
    totalPremium: "₱25,000,000",
    status: "Active",
    modifiedBy: "Roberto Reyes",
    modifiedOn: "03/27/2025",
    action: <SvgIconeye/>
  },
  {
    id: 3,
    companyCode: "CORP-003",
    companyName: "2GO Group Inc.",
    companyType: "Corporate",
    industry: "Logistics & Shipping",
    registrationNo: "SEC-2010-0789123",
    tin: "000-345-678-000",
    address: "Pier 4, North Harbor, Manila",
    city: "Manila",
    province: "Metro Manila",
    contactPerson: "Roberto dela Cruz",
    contactNumber: "+63 2 8528 7000",
    email: "insurance@2go.com.ph",
    website: "www.2go.com.ph",
    totalPolicies: 25,
    totalPremium: "₱8,750,000",
    status: "Active",
    modifiedBy: "Juan Dela Cruz",
    modifiedOn: "03/26/2025",
    action: <SvgIconeye/>
  },
  {
    id: 4,
    companyCode: "CORP-004",
    companyName: "Jollibee Foods Corporation",
    companyType: "Corporate",
    industry: "Food & Beverage",
    registrationNo: "SEC-1978-0456789",
    tin: "000-456-789-000",
    address: "Jollibee Plaza, Ortigas Center",
    city: "Pasig",
    province: "Metro Manila",
    contactPerson: "Ana Marie Garcia",
    contactNumber: "+63 2 8634 1111",
    email: "riskteam@jollibee.com.ph",
    website: "www.jollibee.com.ph",
    totalPolicies: 38,
    totalPremium: "₱6,250,000",
    status: "Active",
    modifiedBy: "Maria Santos",
    modifiedOn: "03/25/2025",
    action: <SvgIconeye/>
  },
  {
    id: 5,
    companyCode: "SME-001",
    companyName: "TechnoHub Solutions Inc.",
    companyType: "SME",
    industry: "Information Technology",
    registrationNo: "SEC-2015-0987654",
    tin: "000-567-890-000",
    address: "BGC Corporate Center, Taguig",
    city: "Taguig",
    province: "Metro Manila",
    contactPerson: "Pedro Gonzales",
    contactNumber: "+63 917 888 9999",
    email: "admin@technohub.ph",
    website: "www.technohub.ph",
    totalPolicies: 8,
    totalPremium: "₱850,000",
    status: "Active",
    modifiedBy: "Juan Dela Cruz",
    modifiedOn: "03/24/2025",
    action: <SvgIconeye/>
  },
  {
    id: 6,
    companyCode: "SME-002",
    companyName: "Filipino Crafts Export Co.",
    companyType: "SME",
    industry: "Manufacturing & Export",
    registrationNo: "SEC-2012-0654987",
    tin: "000-678-901-000",
    address: "Marikina Industrial Zone",
    city: "Marikina",
    province: "Metro Manila",
    contactPerson: "Rosa Fernandez",
    contactNumber: "+63 918 777 6666",
    email: "info@filipinocrafts.ph",
    website: "www.filipinocrafts.ph",
    totalPolicies: 5,
    totalPremium: "₱425,000",
    status: "Active",
    modifiedBy: "Ana Garcia",
    modifiedOn: "03/23/2025",
    action: <SvgIconeye/>
  },
  {
    id: 7,
    companyCode: "IND-001",
    companyName: "Juan Dela Cruz",
    companyType: "Individual",
    industry: "Personal",
    registrationNo: "TIN-123-456-789",
    tin: "123-456-789-000",
    address: "123 Rizal Street, Sampaloc",
    city: "Manila",
    province: "Metro Manila",
    contactPerson: "Self",
    contactNumber: "+63 917 123 4567",
    email: "juan.delacruz@gmail.com",
    website: "",
    totalPolicies: 2,
    totalPremium: "₱45,000",
    status: "Active",
    modifiedBy: "Juan Dela Cruz",
    modifiedOn: "03/22/2025",
    action: <SvgIconeye/>
  },
  {
    id: 8,
    companyCode: "IND-002",
    companyName: "Maria Santos",
    companyType: "Individual",
    industry: "Personal",
    registrationNo: "TIN-234-567-890",
    tin: "234-567-890-000",
    address: "456 Mabini Avenue, Quezon City",
    city: "Quezon City",
    province: "Metro Manila",
    contactPerson: "Self",
    contactNumber: "+63 918 234 5678",
    email: "maria.santos@yahoo.com",
    website: "",
    totalPolicies: 3,
    totalPremium: "₱68,000",
    status: "Active",
    modifiedBy: "Maria Santos",
    modifiedOn: "03/21/2025",
    action: <SvgIconeye/>
  },
  {
    id: 9,
    companyCode: "CORP-005",
    companyName: "Cebu Pacific Air",
    companyType: "Corporate",
    industry: "Aviation",
    registrationNo: "SEC-1996-0321654",
    tin: "000-789-012-000",
    address: "Domestic Road, Pasay City",
    city: "Pasay",
    province: "Metro Manila",
    contactPerson: "Carlos Martinez",
    contactNumber: "+63 2 8702 0888",
    email: "insurance@cebupacificair.com",
    website: "www.cebupacificair.com",
    totalPolicies: 32,
    totalPremium: "₱18,500,000",
    status: "Active",
    modifiedBy: "Roberto Reyes",
    modifiedOn: "03/20/2025",
    action: <SvgIconeye/>
  },
  {
    id: 10,
    companyCode: "CORP-006",
    companyName: "San Miguel Corporation",
    companyType: "Corporate",
    industry: "Conglomerate",
    registrationNo: "SEC-1913-0000001",
    tin: "000-890-123-000",
    address: "40 San Miguel Avenue, Mandaluyong",
    city: "Mandaluyong",
    province: "Metro Manila",
    contactPerson: "Miguel Torres",
    contactNumber: "+63 2 8632 3000",
    email: "riskmanagement@sanmiguel.com.ph",
    website: "www.sanmiguel.com.ph",
    totalPolicies: 85,
    totalPremium: "₱35,000,000",
    status: "Active",
    modifiedBy: "Roberto Reyes",
    modifiedOn: "03/19/2025",
    action: <SvgIconeye/>
  }
];

export default Productdata;